import React from 'react'

export default function DatoCard(props) {
    return (
        <div className="p-col">
            <div className="card-block">
                <p className="value">{props.valor } </p>
                <p className="label">{props.label}</p>
            </div>
        </div>
    )
}
